let ymapsPromise: Promise<IYmaps>;

export function loadYmapsApi(modules: string[], ymapsUrlWithKey: string): Promise<IYmaps> {
  if (!ymapsPromise) {
    ymapsPromise = new Promise((resolve, reject) => {
      if (window.ymaps) {
        resolve(window.ymaps);
        return;
      }

      const e = window.document.createElement('script');
      e.src = `${ymapsUrlWithKey}&lang=ru-RU&load=Map`;
      e.async = true;
      e.defer = true;
      e.onload = () => {
        window.ymaps.ready(() => {
          resolve(window.ymaps);
        });
      };
      e.onerror = () => {
        reject(new Error('Unable to load Yandex Maps API'));
      };
      window.document.body.appendChild(e);
    });
  }

  return ymapsPromise
    .then((ymaps) => {
      return new Promise((resolve, reject) => {
        ymaps.load(modules, () => {
          resolve(ymaps);
        }, reject);
      });
    });
}



// WEBPACK FOOTER //
// ./src/utils/ymaps.ts